export function getTargetId(): string {
  const script = document?.querySelector(
    `script[src="${import.meta.url}"]`
  ) as HTMLScriptElement;
  return script?.dataset?.targetId || '';
}
